<!--复杂列配置界面-->
<template>
  <draggable :list="renderColumns" item-key="name">
    <template #item="{ element }">
      <div class="col-item">
        <el-checkbox v-model="renderColumnMap[element.id]">
          {{ labels[element.id] }}
        </el-checkbox>
      </div>
    </template>
  </draggable>
</template>

<script lang="ts" setup>
import { ref, reactive } from 'vue';
import { GridApi } from 'ag-grid-community';
import Draggable from 'vuedraggable';

import {
  getLayout,
  saveLayout,
  mergeLayout
} from '../../core/LayoutPersistent';

import { usePopup, PopupCtx } from '../../core/EasyPopup';
import { TipError } from '../../core/Errors';
import { emptyObject } from '../../core/Common';

const props = defineProps<{
  api: GridApi;

  // 表格名
  tableName: [string, string]; // 表格名, 如['search', 'sales-order']
  // 主字段名
  columnName: string;

  // id => title
  labels: Record<string, string>;
  // id => visible
  visibles: () => Record<string, boolean>;

  popupCtx?: PopupCtx<true>;
}>();

const complexVisibles = props.visibles();

// 加载保存的列
const persistColumns = getLayout<{ id: string; show: boolean }[]>(
  props.tableName[0],
  ['complex', props.tableName[1], props.columnName],
  [],
  (v) => !!v.push
);

const idShowMap = Object.entries(complexVisibles).map(([id, show]) => ({
  id,
  show
}));

const renderColumns = ref(
  mergeLayout(persistColumns, idShowMap, {
    id: (col) => col.id,
    pinned: () => false,
    isShow: (col) => col.show,
    setShow: (col, show) => {
      col.show = show;
    }
  })
);

const renderColumnMap = reactive<Record<string, boolean>>({});
renderColumns.value.forEach((e) => (renderColumnMap[e.id] = e.show));

// 保存
const popup = usePopup(props);
popup.resultDef(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  if (!Object.entries(renderColumnMap).some(([_, show]) => show)) {
    throw new TipError('至少要选择一个列');
  }

  // 清空是为了object的key重新加入, 顺序重排
  emptyObject(complexVisibles);

  renderColumns.value.forEach((e) => {
    e.show = renderColumnMap[e.id];
    complexVisibles[e.id] = e.show;
  });

  // 保存配置到
  saveLayout(
    props.tableName[0],
    ['complex', props.tableName[1], props.columnName],
    renderColumns.value
  );

  // 调用ag刷新列
  props.api.refreshCells({
    force: true,
    columns: [props.columnName]
  });

  // 关闭弹窗
  popup.done(true);
});
</script>
